import { CS2TIMEDWaitingScreen } from "@/clients/CS2-TIMED/CS2-TIMED_waitingScreen";
import { RacingQrOverlay } from "@/clients/RACING/components/Racing_qr-overlay";
import { CS2TIMEDLeaderboard } from "@/clients/CS2-TIMED/CS2-TIMED_leaderboard";
import { CS2TIMEDEndscreen } from "@/clients/CS2-TIMED/CS2-TIMED_endScreen";
import { RACINGEndScreen } from "@/clients/RACING/RACING_endScreen";
import { brand } from "@/brandVariables/getBandVariables";
import { ClientProps } from "@/hooks/useClientData";
import { Spinner } from "@radix-ui/themes";

import {
  FALLGUYSWaitingScreen,
  FORTNITEEndScreen,
  FORTNITELeaderboard,
  FORTNITEWaitingScreen,
  RACINGLeaderboard,
  RACINGWaitingScreen,
  FALLGUYSLeaderboard,
  FALLGUYSEndScreen,
  FALLGUYS_qrCode,
  RACING_qrCode,
} from "../clients";

export const getUIToRender = ({ clientData }: { clientData: ClientProps }) => {
  const showPageLoader =
    clientData.leaderboard.loading || clientData.challenge.loading;

  // IF NO ACTIVE CHALLENGE & HAS UPCOMING CHALLENGE
  const noActiveChallengeButHasUpcoming =
    !clientData.hasActiveChallenge &&
    clientData.nextChallenges.data &&
    clientData.nextChallenges?.data?.length !== 0 &&
    !clientData.challenge.loading;
  /* ----------------------------------------------------*/

  // IF NO ACTIVE CHALLENGE & HAS NO UPCOMING CHALLENGE
  const noActiveChallengeAndNoUpcomming =
    !clientData.nextChallenges.data &&
    !clientData.challenge.loading &&
    !clientData.challenge.data;

  /* ----------------------------------------------------*/

  // Gets leaderboard based on  brand `layoutKeyValue`
  const uisToRender = {
    LEGO_F1: {
      // leaderboard: (
      //   <RacingQrOverlay
      //     state={clientData.leaderboard.length === 0 ? "top" : "bottom"}
      //   >
      //     <RACINGLeaderboard clientData={clientData} />
      //   </RacingQrOverlay>
      // ),
      leaderboard: <RACINGLeaderboard clientData={clientData} />,
      endScreen: (
        // <RacingQrOverlay state="bottom">
        <RACINGEndScreen clientData={clientData} />
        // </RacingQrOverlay>
      ),
      waitingScreen: (
        // <RacingQrOverlay state="bottom">
        <RACINGWaitingScreen clientData={clientData} />
        // </RacingQrOverlay>
      ),
    },

    LOGITECH: {
      leaderboard: <RACINGLeaderboard clientData={clientData} />,
      endScreen: <RACINGEndScreen clientData={clientData} />,
      waitingScreen: <RACINGWaitingScreen clientData={clientData} />,
    },

    ELGIGANTEN: {
      leaderboard: <RACINGLeaderboard clientData={clientData} />,
      endScreen: <RACINGEndScreen clientData={clientData} />,
      waitingScreen: <RACINGWaitingScreen clientData={clientData} />,
    },

    FORTNITE: {
      leaderboard: <FORTNITELeaderboard clientData={clientData} />,
      endScreen: <FORTNITEEndScreen clientData={clientData} />,
      waitingScreen: <FORTNITEWaitingScreen clientData={clientData} />,
    },
    FALLGUYS: {
      leaderboard: <FALLGUYSLeaderboard clientData={clientData} />,
      endScreen: <FALLGUYSEndScreen clientData={clientData} />,
      waitingScreen: <FALLGUYSWaitingScreen clientData={clientData} />,
    },

    JBLCS2TIMED: {
      leaderboard: <CS2TIMEDLeaderboard clientData={clientData} />,
      endScreen: <CS2TIMEDEndscreen clientData={clientData} />,
      waitingScreen: <CS2TIMEDWaitingScreen clientData={clientData} />,
    },

    TCLCS2TIMED: {
      leaderboard: <CS2TIMEDLeaderboard clientData={clientData} />,
      endScreen: <CS2TIMEDEndscreen clientData={clientData} />,
      waitingScreen: <CS2TIMEDWaitingScreen clientData={clientData} />,
    },

    KEYCHRONCS2TIMED: {
      leaderboard: <CS2TIMEDLeaderboard clientData={clientData} />,
      endScreen: <CS2TIMEDEndscreen clientData={clientData} />,
      waitingScreen: <CS2TIMEDWaitingScreen clientData={clientData} />,
    },
  } as Record<string, Record<string, JSX.Element | undefined>>;

  if (showPageLoader) {
    return <Spinner />;
  }

  if (brand.gameStyle === "fallguys" && window.location.pathname === "/qr") {
    return <FALLGUYS_qrCode />;
  }

  if (brand.gameStyle === "racing" && window.location.pathname === "/qr") {
    return <RACING_qrCode clientData={clientData} />;
  }

  if (!uisToRender[brand.layoutKeyValue]) {
    return <h1>error</h1>;
  }

  if (noActiveChallengeButHasUpcoming) {
    return uisToRender[brand.layoutKeyValue]?.waitingScreen;
  }

  if (noActiveChallengeAndNoUpcomming) {
    return uisToRender[brand.layoutKeyValue]?.endScreen;
  }

  return uisToRender[brand.layoutKeyValue]?.leaderboard;
};
